


'use client';

import React from 'react';
import Dropdown from './dropdown';
import { Link } from '@/i18n/routing'; // Use next-intl's Link
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';
import {useTranslations} from 'next-intl';

const LanguageSelect: React.FC = () => {
  const t = useTranslations('Menu');


  const ManOptions = [
    { code: '1', name: t('padel shoes') , category:'sm'},
    { code: '2', name: t('T-shirt')  , category:'tsm'},
    { code: '3', name: t('sweatshirt') , category:'swsm'},
    { code: '4', name: t('sock') , category:'sockm'},
    { code: '5', name: t('short') , category:'srtm'},
    { code: '6', name: t('polo shirt') , category:'psm'},
    { code: '7', name: t('long pants') , category:'lptsm'},
    { code: '8', name: t('legging') , category:'legm'},
    { code: '9', name: t('jacket') , category:'jcktm'},
    { code: '10', name: t('cap') , category:'capm'},
  ];

  const WomanOptions = [
    { code: '1', name: t('dress') , category:'drs'},
    { code: '2', name: t('visor') , category:'vsr'},
    { code: '3', name: t('top') , category:'top'},
    { code: '4', name: t('padel shoes') , category:'sm'},
    { code: '5', name: t('T-shirt') , category:'tswm'},
    { code: '6', name: t('sweatshirt'), category:'swsw'},
    { code: '7', name: t('sock') , category:'sockm'},
    { code: '8', name: t('short') , category:'srtw'},
    { code: '9', name: t('long pants'), category:'lptsw'},
    { code: '10', name: t('legging')  , category:'legw'},
    { code: '11', name: t('jacket') , category:'jcktw'},
    { code: '12', name: t('cap') , category:'capm'},
  ];

  const RacketsOptions = [
    { code: '1', name: t('beginner') , category:'rkb'},
    { code: '2', name: t('intermediate') , category:'rki'},
    { code: '3', name: t('professional') , category:'rkp'},
  ];

  const AccessoriesOptions = [
    { code: '1', name: t('balls') , category:'bl'},
    { code: '2', name: t('overgrip') , category:'ogri'},
    { code: '3', name: t('racket protector') , category:'rkpt'},
    { code: '4', name: t('protective gear'), category:'ptg'},
    { code: '5', name: t('sunglasses') , category:'sung'},
    { code: '6', name: t('towel') , category:'twl'},
    { code: '7', name: t('resistance bands') , category:'rb'},
    { code: '8', name: t('water bottle') , category:'wb'},
    { code: '9', name: t('sweatbands'), category:'swb'},
  ];

  const router = useRouter(); // Initialize the router
  const locale = useLocale(); // Get the current locale

  const handleSelectClothing = (option: string) => {
   // console.log('Selected Clothing:', option);
  };

  const handleSelectShoes = (option: string) => {
   // console.log('Selected Shoes:', option);
  };

  // Function to handle navigation with query parameters
  const handleNavigateWithQuery = ( query: string) => {
    // Include the locale and query parameters in the URL
    router.push(`/${locale}/p?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="custom:flex gap-6 uppercase select-none tracking-wide font-semibold hidden ">
      <Link href="/blog" rel="preload" >
        <p className="hover:text-bl text-gray-600 font-normal">{t('blog')}</p>
      </Link>
     
        <p className="hover:text-bl text-gray-600 font-normal cursor-pointer"
        onClick={() => handleNavigateWithQuery('jn')}
        >{t('Junior')}
        </p>
    
      <Dropdown title={t('man')} options={ManOptions} onSelect={handleSelectClothing} />
      <Dropdown title={t('woman')} options={WomanOptions} onSelect={handleSelectShoes} />
      <Dropdown title={t('rackets')} options={RacketsOptions} onSelect={handleSelectShoes} />
      <Dropdown title={t('accessories')} options={AccessoriesOptions} onSelect={handleSelectShoes} />

      {/* Use handleNavigateWithQuery to preserve query parameters */}
      <p
        className="hover:text-bl text-gray-600 font-normal cursor-pointer"
        onClick={() => handleNavigateWithQuery('bgs')}
      >
      {t('bags')}
      </p>

      <Link href="/product" rel="preload" >
        <p className="hover:text-bl text-gray-600 font-normal">{t('random')}</p>
      </Link>
    </div>
  );
};

export default LanguageSelect;





